import { RemoteFileInfoRepoImpl } from "domain/repository/Common/RemoteFileInfoRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { GeneralCsvReportRepoImpl } from "domain/repository/GeneralCsvReport/GeneralCsvReportRepoImpl";
import { useGeneralCsvReportTracked } from "presentation/store/GeneralCsvReport/GeneralCsvReportProvider";
import { GeneralCsvReportVM } from "presentation/viewModel/GeneralCsvReport/GeneralCsvReportVM";
import { useMemo } from "react";

export const useGeneralCsvReportVM = () => {
    const [, setGeneralCsvReportState] = useGeneralCsvReportTracked();
    const generalCsvReportVM = useMemo(() =>
        GeneralCsvReportVM({
            dispatch: [setGeneralCsvReportState],
            generalCsvReportRepo: GeneralCsvReportRepoImpl(),
            remoteFileInfoRepo: RemoteFileInfoRepoImpl(),
            companyRepo: CompanyRepoImpl(),
        }), [setGeneralCsvReportState])

    return generalCsvReportVM
}